<div class="d-flex align-items-center mx-2">
  <span class="range-labels" data-testid="min-label">{{ min | number }}</span>

  <div class="slider-wrapper">
    <mat-slider
      class="slider-width always-thumb"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      data-testid="slider"
    >
      <input
        matSliderThumb
        (input)="onValueChange($event.target.value)"
        [value]="value"
        data-testid="slider-input"
      />
    </mat-slider>

    <!-- Always-visible label -->
    <div class="thumb-label" [style.left.px]="clampedPercent">
      {{ value | number }}
    </div>
  </div>

  <span class="range-labels" data-testid="max-label">{{ max | number }}</span>
</div>
